import {
    Dialog, DialogSurface, DialogBody, DialogTitle, Button, DialogContent,
    Card, CardHeader, CardPreview, Text
} from "@fluentui/react-components";
import { Dismiss24Filled, EditRegular } from "@fluentui/react-icons";
import React from "react";
import { faqItems } from "./faq-items";


type FaqModalProps = {
    isOpened?: boolean;
    onClose?: () => void;
}



export const FaqModal: React.FC<FaqModalProps> = (props) => {
    const [open, setOpen] = React.useState(false);


    React.useEffect(() => {
        setOpen(!!props.isOpened);
    }, [props.isOpened]);


    const onModalClose = () => {
        setOpen(false);

        if (props.onClose) {
            props.onClose();
        }

    }






    return <Dialog modalType="alert" open={open} onOpenChange={(event, data) => {
        setOpen(data.open);
        if (!data.open) {
            onModalClose();
        }
    }}>
        <DialogSurface style={{  maxWidth: "1200px" }}>
            <DialogBody style={{ height: "90vh" }}>
                <DialogTitle style={{ textAlign: "center" }} action={<Button appearance="transparent" onClick={onModalClose} icon={<Dismiss24Filled />} />}>
                    Frequently asked questions
                </DialogTitle>
                <DialogContent>
                    <div
                        style={{
                            marginTop:"20px",
                            display: 'grid',
                            gridTemplateColumns: 'repeat(auto-fit, minmax(450px, 1fr))',
                            gap: '10px',
                        }}
                    >
                        {faqItems.map((item, index) => (
                            <Card
                                key={index}
                                style={{
                                    padding: '20px',
                                    minHeight: 100,
                                    display: 'flex',
                                    flexDirection: 'column',
                                    justifyContent: 'flex-start',
                                    boxShadow: '0 2px 6px rgba(0, 0, 0, 0.06)',
                                    transition: 'all 0.2s ease-in-out',
                                    cursor: 'default',
                                }}
                                onMouseEnter={(e) => {
                                    (e.currentTarget as HTMLElement).style.boxShadow =
                                        '0 4px 12px rgba(0, 0, 0, 0.12)';
                                }}
                                onMouseLeave={(e) => {
                                    (e.currentTarget as HTMLElement).style.boxShadow =
                                        '0 2px 6px rgba(0, 0, 0, 0.06)';
                                }}
                            >
                                <Text
                                    weight="semibold"
                                    size={400}
                                    style={{ marginBottom: 8 }}
                                >
                                    {item.question}
                                </Text>
                                <Text size={300}>{item.answer}</Text>
                            </Card>
                        ))}
                    </div>

                </DialogContent>
            </DialogBody>
        </DialogSurface>
    </Dialog >
}